export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11244_UNMARK_TASK_AS_COMPLETED': 'Unmark Task as Completed',
    '_11245_MARK_TASK_AS_COMPLETED': 'Mark Task as Completed',
    '_11246_SET_DUE_DATE': 'Set due date',
    '_11247_MARK_AS_IMPORTANT': 'Mark as Important',
    '_11248_REMOVE_IMPORTANCE': 'Remove Importance',
    '_11249_DELETE_TASK': 'Delete Task',
    '_9479_CONFIRMATION': 'Confirmation',
    '_11250_PLEASE_CONFIRM_YOU_WOULD_LIKE_TO_DELETE_THIS_TASK': 'Please confirm you would like to delete this task',
    '_121_CANCEL': 'Cancel',
    '_11251_CONFIRM': 'Confirm',
    '_11252_EDIT_TASK': 'Edit Task',
    '_11253_SAVE_TASK': 'Save Task',
    '_11254_CANCEL_EDIT': 'Cancel Edit'
};
